function withPublicPath(loader) {
  return function(publicPath) {
    __webpack_public_path__ = publicPath;
    return loader();
  }
}
module.exports = {
  components: {     'ActivityReportSDK': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-ActivityReportSDK.main" */
        '/data/landun/workspace/src/components/ActivityReportSDK/index.tsx'
      )),
    },
    'ActivitySubscribe': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-ActivitySubscribe.main" */
        '/data/landun/workspace/src/components/ActivitySubscribe/index.tsx'
      )),
    },
    'AllPrizeView': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-AllPrizeView.main" */
        '/data/landun/workspace/src/components/AllPrizeView/index.tsx'
      )),
    },
    'AutoPatFace': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-AutoPatFace.main" */
        '/data/landun/workspace/src/components/AutoPatFace/index.tsx'
      )),
    },
    'Background': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-Background.main" */
        '/data/landun/workspace/src/components/Background/index.tsx'
      )),
    },
    'BindGameAccount': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-BindGameAccount.main" */
        '/data/landun/workspace/src/components/BindGameAccount/index.tsx'
      )),
    },
    'BottomSuction': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-BottomSuction.main" */
        '/data/landun/workspace/src/components/BottomSuction/index.tsx'
      )),
    },
    'Buy': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-Buy.main" */
        '/data/landun/workspace/src/components/Buy/index.tsx'
      )),
    },
    'BuyGiftProductList': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-BuyGiftProductList.main" */
        '/data/landun/workspace/src/components/BuyGiftProductList/index.tsx'
      )),
    },
    'BuyGiftTextPicture': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-BuyGiftTextPicture.main" */
        '/data/landun/workspace/src/components/BuyGiftTextPicture/index.tsx'
      )),
    },
    'BuyTask': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-BuyTask.main" */
        '/data/landun/workspace/src/components/BuyTask/index.tsx'
      )),
    },
    'CheckInButton': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-CheckInButton.main" */
        '/data/landun/workspace/src/components/CheckInButton/index.tsx'
      )),
    },
    'CheckInDays': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-CheckInDays.main" */
        '/data/landun/workspace/src/components/CheckInDays/index.tsx'
      )),
    },
    'CountDown': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-CountDown.main" */
        '/data/landun/workspace/src/components/CountDown/index.tsx'
      )),
    },
    'CountryChannelDisplay': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-CountryChannelDisplay.main" */
        '/data/landun/workspace/src/components/CountryChannelDisplay/index.tsx'
      )),
    },
    'CumulativeRecharge': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-CumulativeRecharge.main" */
        '/data/landun/workspace/src/components/CumulativeRecharge/index.tsx'
      )),
    },
    'CumulativeRechargePop': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-CumulativeRechargePop.main" */
        '/data/landun/workspace/src/components/CumulativeRechargePop/index.tsx'
      )),
    },
    'CumulativeRechargeProductList': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-CumulativeRechargeProductList.main" */
        '/data/landun/workspace/src/components/CumulativeRechargeProductList/index.tsx'
      )),
    },
    'CumulativeRechargeProgress': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-CumulativeRechargeProgress.main" */
        '/data/landun/workspace/src/components/CumulativeRechargeProgress/index.tsx'
      )),
    },
    'CyclicCumulativeRecharge': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-CyclicCumulativeRecharge.main" */
        '/data/landun/workspace/src/components/CyclicCumulativeRecharge/index.tsx'
      )),
    },
    'DiscountTask': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-DiscountTask.main" */
        '/data/landun/workspace/src/components/DiscountTask/index.tsx'
      )),
    },
    'DrawerWithLogin': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-DrawerWithLogin.main" */
        '/data/landun/workspace/src/components/DrawerWithLogin/index.tsx'
      )),
    },
    'EventBtn': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-EventBtn.main" */
        '/data/landun/workspace/src/components/EventBtn/index.tsx'
      )),
    },
    'ExchangePointsDisplay': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-ExchangePointsDisplay.main" */
        '/data/landun/workspace/src/components/ExchangePointsDisplay/index.tsx'
      )),
    },
    'ExchangeShopList': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-ExchangeShopList.main" */
        '/data/landun/workspace/src/components/ExchangeShopList/index.tsx'
      )),
    },
    'FooterLink': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-FooterLink.main" */
        '/data/landun/workspace/src/components/FooterLink/index.tsx'
      )),
    },
    'GameLipassLogin': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-GameLipassLogin.main" */
        '/data/landun/workspace/src/components/GameLipassLogin/index.tsx'
      )),
    },
    'Guidelines': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-Guidelines.main" */
        '/data/landun/workspace/src/components/Guidelines/index.tsx'
      )),
    },
    'Header': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-Header.main" */
        '/data/landun/workspace/src/components/Header/index.tsx'
      )),
    },
    'HelpEventRecord': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-HelpEventRecord.main" */
        '/data/landun/workspace/src/components/HelpEventRecord/index.tsx'
      )),
    },
    'HelpGuestView': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-HelpGuestView.main" */
        '/data/landun/workspace/src/components/HelpGuestView/index.tsx'
      )),
    },
    'HelpHostView': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-HelpHostView.main" */
        '/data/landun/workspace/src/components/HelpHostView/index.tsx'
      )),
    },
    'I18nContainer': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-I18nContainer.main" */
        '/data/landun/workspace/src/components/I18nContainer/index.tsx'
      )),
    },
    'IframeEmbedPage': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-IframeEmbedPage.main" */
        '/data/landun/workspace/src/components/IframeEmbedPage/index.tsx'
      )),
    },
    'InputEmailCom': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-InputEmailCom.main" */
        '/data/landun/workspace/src/components/InputEmailCom/index.tsx'
      )),
    },
    'LipassBindActivity': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-LipassBindActivity.main" */
        '/data/landun/workspace/src/components/LipassBindActivity/index.tsx'
      )),
    },
    'LotteryCircleRoulette': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-LotteryCircleRoulette.main" */
        '/data/landun/workspace/src/components/LotteryCircleRoulette/index.tsx'
      )),
    },
    'LotteryCouponDisplay': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-LotteryCouponDisplay.main" */
        '/data/landun/workspace/src/components/LotteryCouponDisplay/index.tsx'
      )),
    },
    'LotteryExecButton': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-LotteryExecButton.main" */
        '/data/landun/workspace/src/components/LotteryExecButton/index.tsx'
      )),
    },
    'LotteryModelConfig': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-LotteryModelConfig.main" */
        '/data/landun/workspace/src/components/LotteryModelConfig/index.tsx'
      )),
    },
    'LotteryPoolSwitch': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-LotteryPoolSwitch.main" */
        '/data/landun/workspace/src/components/LotteryPoolSwitch/index.tsx'
      )),
    },
    'LotteryProductDisplay': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-LotteryProductDisplay.main" */
        '/data/landun/workspace/src/components/LotteryProductDisplay/index.tsx'
      )),
    },
    'LotteryRoll': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-LotteryRoll.main" */
        '/data/landun/workspace/src/components/LotteryRoll/index.tsx'
      )),
    },
    'LotteryRollInit': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-LotteryRollInit.main" */
        '/data/landun/workspace/src/components/LotteryRollInit/index.tsx'
      )),
    },
    'LotterySquareRoulette': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-LotterySquareRoulette.main" */
        '/data/landun/workspace/src/components/LotterySquareRoulette/index.tsx'
      )),
    },
    'LuckDrawTimes': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-LuckDrawTimes.main" */
        '/data/landun/workspace/src/components/LuckDrawTimes/index.tsx'
      )),
    },
    'MobilePicker': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-MobilePicker.main" */
        '/data/landun/workspace/src/components/MobilePicker/index.tsx'
      )),
    },
    'OtherActivityList': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-OtherActivityList.main" */
        '/data/landun/workspace/src/components/OtherActivityList/index.tsx'
      )),
    },
    'Picture': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-Picture.main" */
        '/data/landun/workspace/src/components/Picture/index.tsx'
      )),
    },
    'PopRedeemCode': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-PopRedeemCode.main" */
        '/data/landun/workspace/src/components/PopRedeemCode/index.tsx'
      )),
    },
    'PopupLinkSelector': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-PopupLinkSelector.main" */
        '/data/landun/workspace/src/components/PopupLinkSelector/index.tsx'
      )),
    },
    'PrizeList': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-PrizeList.main" */
        '/data/landun/workspace/src/components/PrizeList/index.tsx'
      )),
    },
    'ProductListConfig': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-ProductListConfig.main" */
        '/data/landun/workspace/src/components/ProductListConfig/index.tsx'
      )),
    },
    'PurchaseUCBtn': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-PurchaseUCBtn.main" */
        '/data/landun/workspace/src/components/PurchaseUCBtn/index.tsx'
      )),
    },
    'RedPacketLottery': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-RedPacketLottery.main" */
        '/data/landun/workspace/src/components/RedPacketLottery/index.tsx'
      )),
    },
    'RedeemCodeTypeList': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-RedeemCodeTypeList.main" */
        '/data/landun/workspace/src/components/RedeemCodeTypeList/index.tsx'
      )),
    },
    'RegisterGift': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-RegisterGift.main" */
        '/data/landun/workspace/src/components/RegisterGift/index.tsx'
      )),
    },
    'RichText': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-RichText.main" */
        '/data/landun/workspace/src/components/RichText/index.tsx'
      )),
    },
    'SaleWithPresentList': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-SaleWithPresentList.main" */
        '/data/landun/workspace/src/components/SaleWithPresentList/index.tsx'
      )),
    },
    'SeasonRechargeAccumulate': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-SeasonRechargeAccumulate.main" */
        '/data/landun/workspace/src/components/SeasonRechargeAccumulate/index.tsx'
      )),
    },
    'SeasonRechargeI18nTextPicture': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-SeasonRechargeI18nTextPicture.main" */
        '/data/landun/workspace/src/components/SeasonRechargeI18nTextPicture/index.tsx'
      )),
    },
    'SeasonRechargeTextPicture': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-SeasonRechargeTextPicture.main" */
        '/data/landun/workspace/src/components/SeasonRechargeTextPicture/index.tsx'
      )),
    },
    'SeasonRechargeUnlockPurchase': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-SeasonRechargeUnlockPurchase.main" */
        '/data/landun/workspace/src/components/SeasonRechargeUnlockPurchase/index.tsx'
      )),
    },
    'SeasonRechargeUserInfo': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-SeasonRechargeUserInfo.main" */
        '/data/landun/workspace/src/components/SeasonRechargeUserInfo/index.tsx'
      )),
    },
    'SendEmail': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-SendEmail.main" */
        '/data/landun/workspace/src/components/SendEmail/index.tsx'
      )),
    },
    'Share': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-Share.main" */
        '/data/landun/workspace/src/components/Share/index.tsx'
      )),
    },
    'ShareImage': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-ShareImage.main" */
        '/data/landun/workspace/src/components/ShareImage/index.tsx'
      )),
    },
    'SlideBanner': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-SlideBanner.main" */
        '/data/landun/workspace/src/components/SlideBanner/index.tsx'
      )),
    },
    'StepBars': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-StepBars.main" */
        '/data/landun/workspace/src/components/StepBars/index.tsx'
      )),
    },
    'StepGuide': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-StepGuide.main" */
        '/data/landun/workspace/src/components/StepGuide/index.tsx'
      )),
    },
    'StickyFooter': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-StickyFooter.main" */
        '/data/landun/workspace/src/components/StickyFooter/index.tsx'
      )),
    },
    'SubPageConfig': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-SubPageConfig.main" */
        '/data/landun/workspace/src/components/SubPageConfig/index.tsx'
      )),
    },
    'SubPageJumpButton': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-SubPageJumpButton.main" */
        '/data/landun/workspace/src/components/SubPageJumpButton/index.tsx'
      )),
    },
    'Subscribe': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-Subscribe.main" */
        '/data/landun/workspace/src/components/Subscribe/index.tsx'
      )),
    },
    'SubscribeActivityTotal': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-SubscribeActivityTotal.main" */
        '/data/landun/workspace/src/components/SubscribeActivityTotal/index.tsx'
      )),
    },
    'SubscribePop': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-SubscribePop.main" */
        '/data/landun/workspace/src/components/SubscribePop/index.tsx'
      )),
    },
    'SwiperProductList': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-SwiperProductList.main" */
        '/data/landun/workspace/src/components/SwiperProductList/index.tsx'
      )),
    },
    'TabsTwo': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-TabsTwo.main" */
        '/data/landun/workspace/src/components/TabsTwo/index.tsx'
      )),
    },
    'TaskTextPicture': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-TaskTextPicture.main" */
        '/data/landun/workspace/src/components/TaskTextPicture/index.tsx'
      )),
    },
    'TeamGroupCardList': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-TeamGroupCardList.main" */
        '/data/landun/workspace/src/components/TeamGroupCardList/index.tsx'
      )),
    },
    'TeamGroupStatusCard': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-TeamGroupStatusCard.main" */
        '/data/landun/workspace/src/components/TeamGroupStatusCard/index.tsx'
      )),
    },
    'TeamLaunchTips': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-TeamLaunchTips.main" */
        '/data/landun/workspace/src/components/TeamLaunchTips/index.tsx'
      )),
    },
    'TeamMyGroupList': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-TeamMyGroupList.main" */
        '/data/landun/workspace/src/components/TeamMyGroupList/index.tsx'
      )),
    },
    'TeamPurchaseList': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-TeamPurchaseList.main" */
        '/data/landun/workspace/src/components/TeamPurchaseList/index.tsx'
      )),
    },
    'TeamSingleCard': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-TeamSingleCard.main" */
        '/data/landun/workspace/src/components/TeamSingleCard/index.tsx'
      )),
    },
    'Template': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-Template.main" */
        '/data/landun/workspace/src/components/Template/index.tsx'
      )),
    },
    'UCBuyFree': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-UCBuyFree.main" */
        '/data/landun/workspace/src/components/UCBuyFree/index.tsx'
      )),
    },
    'UCInitPage': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-UCInitPage.main" */
        '/data/landun/workspace/src/components/UCInitPage/index.tsx'
      )),
    },
    'UCLeftLottery': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-UCLeftLottery.main" */
        '/data/landun/workspace/src/components/UCLeftLottery/index.tsx'
      )),
    },
    'UCLottery': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-UCLottery.main" */
        '/data/landun/workspace/src/components/UCLottery/index.tsx'
      )),
    },
    'UCRecharge': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-UCRecharge.main" */
        '/data/landun/workspace/src/components/UCRecharge/index.tsx'
      )),
    },
    'UCRightLottery': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-UCRightLottery.main" */
        '/data/landun/workspace/src/components/UCRightLottery/index.tsx'
      )),
    },
    'UserInfo': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-UserInfo.main" */
        '/data/landun/workspace/src/components/UserInfo/index.tsx'
      )),
    },
    'UserInfoCom': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-UserInfoCom.main" */
        '/data/landun/workspace/src/components/UserInfoCom/index.tsx'
      )),
    },
    'VerticalButtonGroup': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-VerticalButtonGroup.main" */
        '/data/landun/workspace/src/components/VerticalButtonGroup/index.tsx'
      )),
    },
    'VipInfoDisplay': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-VipInfoDisplay.main" */
        '/data/landun/workspace/src/components/VipInfoDisplay/index.tsx'
      )),
    },
    'VipTaskList': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-VipTaskList.main" */
        '/data/landun/workspace/src/components/VipTaskList/index.tsx'
      )),
    },
    'ZosGetGiftByUc': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-ZosGetGiftByUc.main" */
        '/data/landun/workspace/src/components/ZosGetGiftByUc/index.tsx'
      )),
    },
    'ZosLoginGame': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-ZosLoginGame.main" */
        '/data/landun/workspace/src/components/ZosLoginGame/index.tsx'
      )),
    },
    'ZosUnlockPurchase': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-ZosUnlockPurchase.main" */
        '/data/landun/workspace/src/components/ZosUnlockPurchase/index.tsx'
      )),
    },
    'base_button_back': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-base_button_back.main" */
        '/data/landun/workspace/src/components/base_button_back/index.tsx'
      )),
    },
    'base_button_buy_jieou': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-base_button_buy_jieou.main" */
        '/data/landun/workspace/src/components/base_button_buy_jieou/index.tsx'
      )),
    },
    'base_button_checkout': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-base_button_checkout.main" */
        '/data/landun/workspace/src/components/base_button_checkout/index.tsx'
      )),
    },
    'base_button_login': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-base_button_login.main" */
        '/data/landun/workspace/src/components/base_button_login/index.tsx'
      )),
    },
    'base_button_popup': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-base_button_popup.main" */
        '/data/landun/workspace/src/components/base_button_popup/index.tsx'
      )),
    },
    'base_checkout': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-base_checkout.main" */
        '/data/landun/workspace/src/components/base_checkout/index.tsx'
      )),
    },
    'base_country_switch': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-base_country_switch.main" */
        '/data/landun/workspace/src/components/base_country_switch/index.tsx'
      )),
    },
    'base_custom_logic': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-base_custom_logic.main" */
        '/data/landun/workspace/src/components/base_custom_logic/index.tsx'
      )),
    },
    'base_dynamic_buy': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-base_dynamic_buy.main" */
        '/data/landun/workspace/src/components/base_dynamic_buy/index.tsx'
      )),
    },
    'base_extend_logic': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-base_extend_logic.main" */
        '/data/landun/workspace/src/components/base_extend_logic/index.tsx'
      )),
    },
    'base_extend_product': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-base_extend_product.main" */
        '/data/landun/workspace/src/components/base_extend_product/index.tsx'
      )),
    },
    'base_extend_scene': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-base_extend_scene.main" */
        '/data/landun/workspace/src/components/base_extend_scene/index.tsx'
      )),
    },
    'base_extend_user': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-base_extend_user.main" */
        '/data/landun/workspace/src/components/base_extend_user/index.tsx'
      )),
    },
    'base_force_landscape': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-base_force_landscape.main" */
        '/data/landun/workspace/src/components/base_force_landscape/index.tsx'
      )),
    },
    'base_help': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-base_help.main" */
        '/data/landun/workspace/src/components/base_help/index.tsx'
      )),
    },
    'base_i18n_switch': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-base_i18n_switch.main" */
        '/data/landun/workspace/src/components/base_i18n_switch/index.tsx'
      )),
    },
    'base_midasbuy_embed': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-base_midasbuy_embed.main" */
        '/data/landun/workspace/src/components/base_midasbuy_embed/index.tsx'
      )),
    },
    'base_player_info': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-base_player_info.main" */
        '/data/landun/workspace/src/components/base_player_info/index.tsx'
      )),
    },
    'base_popup': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-base_popup.main" */
        '/data/landun/workspace/src/components/base_popup/index.tsx'
      )),
    },
    'base_popup_activity_end': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-base_popup_activity_end.main" */
        '/data/landun/workspace/src/components/base_popup_activity_end/index.tsx'
      )),
    },
    'base_popup_error': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-base_popup_error.main" */
        '/data/landun/workspace/src/components/base_popup_error/index.tsx'
      )),
    },
    'base_router': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-base_router.main" */
        '/data/landun/workspace/src/components/base_router/index.tsx'
      )),
    },
    'base_select_page': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-base_select_page.main" */
        '/data/landun/workspace/src/components/base_select_page/index.tsx'
      )),
    },
    'base_select_zone': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-base_select_zone.main" */
        '/data/landun/workspace/src/components/base_select_zone/index.tsx'
      )),
    },
    'base_swiper': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-base_swiper.main" */
        '/data/landun/workspace/src/components/base_swiper/index.tsx'
      )),
    },
    'base_task': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-base_task.main" */
        '/data/landun/workspace/src/components/base_task/index.tsx'
      )),
    },
    'base_video': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-base_video.main" */
        '/data/landun/workspace/src/components/base_video/index.tsx'
      )),
    },
    'play_choujiang_bufanghui': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-play_choujiang_bufanghui.main" */
        '/data/landun/workspace/src/components/play_choujiang_bufanghui/index.tsx'
      )),
    },
    'play_choujiang_jiangliyilan': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-play_choujiang_jiangliyilan.main" */
        '/data/landun/workspace/src/components/play_choujiang_jiangliyilan/index.tsx'
      )),
    },
    'play_coupon_no_ui': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-play_coupon_no_ui.main" */
        '/data/landun/workspace/src/components/play_coupon_no_ui/index.tsx'
      )),
    },
    'play_jietimaizeng_no_ui': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-play_jietimaizeng_no_ui.main" */
        '/data/landun/workspace/src/components/play_jietimaizeng_no_ui/index.tsx'
      )),
    },
    'play_jifen_no_ui': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-play_jifen_no_ui.main" */
        '/data/landun/workspace/src/components/play_jifen_no_ui/index.tsx'
      )),
    },
    'play_leichong_no_ui': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-play_leichong_no_ui.main" */
        '/data/landun/workspace/src/components/play_leichong_no_ui/index.tsx'
      )),
    },
    'play_share_free_gift': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-play_share_free_gift.main" */
        '/data/landun/workspace/src/components/play_share_free_gift/index.tsx'
      )),
    },
    'play_team_no_ui': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-play_team_no_ui.main" */
        '/data/landun/workspace/src/components/play_team_no_ui/index.tsx'
      )),
    },
    'play_topup_midasbuy': {
      loader: withPublicPath(() => import(
        /* webpackChunkName: "component-play_topup_midasbuy.main" */
        '/data/landun/workspace/src/components/play_topup_midasbuy/index.tsx'
      )),
    } },
  plugins: {  },
  actions: {  },
}